enum UserStatusEnum {
  ACTIVE = 'active',
  PENDING = 'pending',
}

export default UserStatusEnum;
